/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum edsn_CSPproduct {
    CAPACITEITSBEPERKING = 'Capaciteitsbeperking',
    REDISPATCH = 'Redispatch',
}
